import React, { Component } from "react";
import { 
  TextField, 
  Button, 
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Alert } from "@material-ui/lab";
import LockIcon from "@material-ui/icons/Lock";

import { withFirebase } from "../Firebase";

const styles = (theme) => ({
  form: {
    width: '100%',
  },
  textField: {
    marginBottom: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      '&:hover fieldset': {
        borderColor: '#667eea',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#667eea',
      },
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#667eea',
    },
  },
  button: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: '#ffffff',
    padding: theme.spacing(1.5),
    borderRadius: '8px',
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
    '&:hover': {
      background: 'linear-gradient(135deg, #5568d3 0%, #6b3f91 100%)',
      boxShadow: '0 6px 20px rgba(102, 126, 234, 0.6)',
    },
    '&:disabled': {
      background: '#e0e0e0',
      color: '#9e9e9e',
    },
  },
  successAlert: {
    marginTop: theme.spacing(2),
    borderRadius: '8px',
  },
  errorAlert: {
    marginTop: theme.spacing(2),
    borderRadius: '8px',
  },
});

const INITIAL_STATE = {
  passwordOne: "",
  passwordTwo: "",
  error: null,
  success: false,
};

class PasswordChangeForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const { passwordOne } = this.state;

    this.props.firebase
      .doPasswordUpdate(passwordOne)
      .then(() => {
        this.setState({ ...INITIAL_STATE, success: true });
        setTimeout(() => {
          this.setState({ success: false });
        }, 3000);
      })
      .catch((error) => {
        this.setState({ error });
      });

    event.preventDefault();
  };

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { passwordOne, passwordTwo, error, success } = this.state;
    const { classes } = this.props;

    const isInvalid = passwordOne !== passwordTwo || passwordOne === "" || passwordOne.length < 6;

    return (
      <form onSubmit={this.onSubmit} className={classes.form}>
        <TextField
          name="passwordOne"
          value={passwordOne}
          onChange={this.onChange}
          type="password"
          label="Nova Senha"
          placeholder="Mínimo 6 caracteres"
          fullWidth
          variant="outlined"
          className={classes.textField}
        />
        <TextField
          name="passwordTwo"
          value={passwordTwo}
          onChange={this.onChange}
          type="password"
          label="Confirmar Nova Senha"
          placeholder="Digite a senha novamente"
          fullWidth
          variant="outlined"
          className={classes.textField}
        />
        
        <Button 
          disabled={isInvalid} 
          type="submit"
          fullWidth
          className={classes.button}
          startIcon={<LockIcon />}
        >
          Alterar Senha
        </Button>

        {success && (
          <Alert severity="success" className={classes.successAlert}>
            Senha alterada com sucesso!
          </Alert>
        )}

        {error && (
          <Alert severity="error" className={classes.errorAlert}>
            {error.message}
          </Alert>
        )}
      </form>
    );
  }
}

export default withFirebase(withStyles(styles)(PasswordChangeForm));
